<template>
  <div>
    <b-popover
      target="nav1"
      custom-class="coming-soon"
      triggers="focus"
      placement="bottom"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
    <b-popover
      target="nav4"
      custom-class="coming-soon"
      triggers="focus"
      placement="bottom"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
    <b-popover
      target="nav5"
      custom-class="coming-soon"
      triggers="focus"
      placement="bottom"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
